import { render, staticRenderFns } from "./AccountsInvestments.vue?vue&type=template&id=278596c4&"
import script from "./AccountsInvestments.vue?vue&type=script&setup=true&lang=js&"
export * from "./AccountsInvestments.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports